import React, { useState } from 'react';

export default function CTA({
  contactSubject = '',
  setContactSubject = () => {},
  isContactOpen = false,
  setIsContactOpen = () => {}
}) {
  const [submitStatus, setSubmitStatus] = useState('idle'); // 'idle' | 'submitting' | 'success'

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    setSubmitStatus('submitting');
    
    const formData = new FormData(form);
    const name = formData.get('name')?.toString().trim() || 'Someone';
    const message = formData.get('message')?.toString().trim() || '';
    
    // Use the controlled state subject, or fallback to a default if empty
    const subject = contactSubject.trim() ? contactSubject.trim() : `New Inquiry from ${name}`;

    try {
      await fetch('https://connect.pabbly.com/webhook-listener/webhook/IjU3NjEwNTY4MDYzNDA0MzE1MjZmNTUzZCI_3D_pc/IjU3NjcwNTZlMDYzMzA0MzY1MjZjNTUzNzUxMzEi_pc', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name,
          subject,
          message,
          timestamp: new Date().toISOString()
        })
      });

      // Clear the fields and show success state
      form.reset();
      setContactSubject('');
      setSubmitStatus('success');
      
      // Revert button text back to normal after 3 seconds
      setTimeout(() => {
        setSubmitStatus('idle');
      }, 3000);

    } catch (error) {
      console.error('Error submitting form:', error);
      alert('Failed to send message. Please try again.');
      setSubmitStatus('idle');
    }
  };

  return (
    <section id="cta" className="py-24 px-6 relative flex items-center justify-center">
      <div className="liquid-glass max-w-2xl mx-auto w-full rounded-3xl p-8 md:p-16 text-center border border-white/5">
        <h2 className="font-instrument italic text-4xl md:text-6xl text-white leading-tight">
          "Let's build something <br /> worth watching."
        </h2>
        
        <p className="text-white/60 font-sans text-base max-w-md mx-auto mt-6 leading-relaxed">
          Fill out the quick intake form and I'll follow up within 1 business day. Intro pricing available for the first 3 bookings.
        </p>

        <a 
          href="https://portal.wearesanstitre.com/catalog/amazon-product-video"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block mt-10 bg-white text-black font-sans text-base font-semibold px-10 py-4 rounded-full hover:bg-white/90 transition-transform hover:scale-105 active:scale-95"
        >
          Start Your Project &rarr;
        </a>

        <p className="text-white/30 text-xs mt-5 font-sans">
          No commitment required &middot; Takes 3 minutes
        </p>

        {/* Collapsible Contact Form Section */}
        <div className="mt-8 flex flex-col items-center">
          <button 
            onClick={() => setIsContactOpen(!isContactOpen)}
            className="text-white/50 hover:text-white text-sm font-sans transition-colors flex items-center gap-2 group"
          >
            Or Contact Us
            <svg 
              className={`w-4 h-4 transition-transform duration-300 ease-in-out ${isContactOpen ? 'rotate-180' : 'group-hover:translate-y-0.5'}`}
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </button>

          <div 
            className={`overflow-hidden transition-all duration-500 ease-[cubic-bezier(0.4,0,0.2,1)] w-full max-w-md ${
              isContactOpen ? 'max-h-[600px] opacity-100 mt-6' : 'max-h-0 opacity-0 mt-0 pointer-events-none'
            }`}
          >
            <form onSubmit={handleContactSubmit} className="flex flex-col gap-3 text-left">
              <input 
                name="name"
                type="text" 
                placeholder="Your Name" 
                required
                className="bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white text-sm outline-none focus:border-white/30 transition-colors focus:bg-white/10 placeholder:text-white/30"
              />
              <input 
                name="subject"
                type="text" 
                placeholder="Subject"
                required 
                value={contactSubject}
                onChange={(e) => setContactSubject(e.target.value)}
                className="bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white text-sm outline-none focus:border-white/30 transition-colors focus:bg-white/10 placeholder:text-white/30"
              />
              <textarea 
                name="message"
                placeholder="How can we help?" 
                required
                rows={4}
                className="bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white text-sm outline-none focus:border-white/30 transition-colors resize-none focus:bg-white/10 placeholder:text-white/30"
              ></textarea>
              <button 
                type="submit" 
                disabled={submitStatus === 'submitting' || submitStatus === 'success'}
                className="bg-white/10 hover:bg-white/20 text-white border border-white/20 rounded-xl py-3 text-sm font-medium transition-colors mt-1 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {submitStatus === 'submitting' ? 'Sending...' : submitStatus === 'success' ? 'Message sent!' : 'Send Message'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}